import { render, staticRenderFns } from "./Station.vue?vue&type=template&id=5a78951c&scoped=true"
import script from "./Station.vue?vue&type=script&lang=js"
export * from "./Station.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a78951c",
  null
  
)

export default component.exports